import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FILE_CAP } from 'src/app/Interfaces/Libraries/Library-FIN-int/FileCAP.interface';
import { Same_File_FIN } from 'src/app/Interfaces/Libraries/Library-FIN-int/Same-File-FIN.interface';

@Component({
    selector: 'app-modal-same-files-fin',
    templateUrl: './modal-same-files-fin.component.html',
    styleUrls: ['./modal-same-files-fin.component.scss', '../../../../../Styles/GlobalStyles.css', '../../../../../Styles/LibrayGlobal.css'],
    standalone: false
})
export class ModalSameFilesFINComponent implements OnChanges {

  @Input() FileAddSameFIN!: FILE_CAP;
  @Input() AllFileSame!: Same_File_FIN[];
  @Input() ModalNumber!: number;

  ngOnChanges(): void {
  }


  //-================== FUNCTION FOR OPEN OR CLOSE MODAL SAME FILES ==================-\\
  public Toggle_Modal_Same_Files_FIN(): void {
    let ModalSameFHFIN = document.getElementById(`ModalSameFHFIN${this.ModalNumber}`) as HTMLDivElement;
    let ModalSameFilesFIN = document.getElementById(`ModalSameFilesFIN${this.ModalNumber}`) as HTMLDivElement;

    ModalSameFHFIN.classList.toggle('active');
    ModalSameFilesFIN.classList.toggle('active');
  }

}
